<template>
    <div class="container">
        
        <div class="row mt-5 mb-4">
            <div class="col-12 text-center">
                <h1>Tell us about your project</h1>
                <p>Ready to get started?</p>
                <hr class="header-underline">
            </div>
        </div>

        <div class="row mt-5 globe-background">
            <div class="col-lg-6"></div>
            <div class="col-lg-6 mt-4">
                <div class="row">
                    <div class="col-lg-3">
                        <h6><i class="fas fa-map-marker-alt" aria-hidden="true"></i> LOCATIONS:</h6>  
                    </div>

                    <div class="col-lg-9">
                        <h6>Providence</h6>
                        <h6>Rhode Island, USA</h6>

                        <br>
                        <h6>Athens</h6>
                        <h6>Attica, Greece</h6>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-lg-3">
                        <h6><i class="fas fa-phone" aria-hidden="true"></i> PHONE:</h6>  
                    </div>

                    <div class="col-lg-9">
                        <h6><a class="text-dark" href="tel:+14015987858">(401) 598-7858</a></h6>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-lg-3">
                        <h6><i class="fas fa-envelope" aria-hidden="true"></i> EMAIL:</h6>  
                    </div>

                    <div class="col-lg-9">
                        <h6><a class="text-dark" href="mailto:antonios.tsamourtzis@gmail.com">antonios.tsamourtzis@gmail.com</a></h6>
                    </div>
                </div>

               <div class="row my-5">
                    <div class="col-lg-2 col-3 text-center">
                        <a href="https://www.linkedin.com/in/antonios-tsamourtzis/" target="_blank">
                            <div class="social text-light">
                                <i class="fab fa-linkedin fa-2x mt-3"></i>
                            </div>
                        </a>
                    </div>

                     <!-- <div class="col-lg-2 col-3 text-center">
                        <a href="https://gitlab.com/Tsamourtzis" target="_blank">
                            <div class="social text-light">
                                <i class="fab fa-gitlab fa-2x mt-3"></i>
                            </div>
                        </a>
                    </div>

                    <div class="col-lg-2 col-3 text-center">
                        <a href="https://github.com/antonishg" target="_blank">
                            <div class="social text-light">
                                <i class="fab fa-github fa-2x mt-3"></i>
                            </div>
                        </a>
                    </div> -->

                    <!-- <div class="col-lg-2 col-3 text-center">
                        <a href="https://twitter.com/antonis_hg" target="_blank">
                            <div class="social text-light">
                                <i class="fab fa-twitter fa-2x mt-3"></i>
                            </div>
                        </a>
                    </div> -->
                    
                    <div class="col-4"></div>
                </div>
            </div>
            
            <Loading v-if="loading == true"/>
        </div>
    </div>
</template>

<script>
    import IPAddress from '../controllers/ipAddress.controller';
    import Email from '../controllers/email.controller';
    import Loading from '../components/Loading';

    export default {
        name: 'Contact',
        components: {
            Loading
        },
        data: function() {
            return {
                email: "",
                name: "",
                message: "",
                loading: false,
                errorMessage: "",
                successMessage: ""
            }
        },
        methods: {
            async submitContact() {
                this.errorMessage = "";
                this.successMessage = "";

                if (!this.email || !this.name || !this.message) {
                    alert('Please fill out all fields');
                    return;
                }

                this.loading = true;

                let ipAddress = await IPAddress.get();

                let sent = await Email.contact(this.email, this.name, this.message, ipAddress);

                if (sent === false) {
                    this.errorMessage = "Something went wrong while submitting your form.";
                } else {
                    this.successMessage = "Thank you! We will get in touch with you shortly.";
                }

                this.loading = false;

            }
        }
    }
</script>